import Typography, { type TypographyProps } from '@mui/material/Typography';
import type { ReactNode } from 'react';

type FormFieldLabelProps = TypographyProps<'label'>;

export function FormFieldLabel({ children, sx, ...props }: FormFieldLabelProps): ReactNode {
  return (
    <Typography
      component="label"
      {...props}
      sx={[
        {
          display: 'block',
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          color: 'text.primary',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Typography>
  );
}
